import styled from '@emotion/styled'

import {Body, Content, PopUp} from '@vio/atlas/PopUp'
import {cssTheme} from '@vio/atlas/themes'
import {linariaMq} from '@vio/atlas/utils/breakpoints'

const RIGHT_PANEL_WIDTH = 420
const DESKTOP_MAX_HEIGHT = 978
export const DESKTOP_MAX_WIDTH = 1600

export const StyledPopUp = styled(PopUp)`
  & > div {
    padding: ${cssTheme.layout.spacing.s950};
  }
  &.--is-chromatic {
    & > div {
      padding: ${cssTheme.layout.spacing.s700};
    }
    max-width: 2064px;
    max-height: 1064px;
    ${Content} {
      max-width: 2000px;
      max-height: 1000px;
    }
  }
  ${Content} {
    width: calc(100vw - ${cssTheme.layout.spacing.s950});
    height: calc(100vh - ${cssTheme.layout.spacing.s950});

    ${linariaMq.desktopLg} {
      max-height: ${DESKTOP_MAX_HEIGHT}px;
    }
  }
  ${Body} {
    height: 100%;
  }
`

export const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  height: 100%;
  overflow: hidden;
  flex-direction: column;
  ${linariaMq.desktopMd} {
    flex-direction: row;
  }
`

export const MainContentPanel = styled.div`
  width: 100%;
  height: calc(100% - 67px);

  ${linariaMq.desktopMd} {
    height: 100%;
    width: calc(100% - ${RIGHT_PANEL_WIDTH}px);
  }
`

export const GalleryDetailsPanel = styled.div`
  width: 100%;
  height: 100%;
  overflow: auto;
  border-inline-start: 1px solid;
  border-color: ${cssTheme.colors.border.neutral.secondary};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
  ${linariaMq.desktopMd} {
    max-width: ${RIGHT_PANEL_WIDTH}px;
  }
`
export const BottomCTAWrapper = styled.div`
  position: absolute;
  bottom: 0;
  width: 100%;
  z-index: 2;
  background-color: ${cssTheme.colors.background.neutral.primary};
  box-shadow: ${cssTheme.shadows.fixedReverse};
  border-radius: ${cssTheme.layout.radius.lg} ${cssTheme.layout.radius.lg} 0 0;
`
